import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {NavLink, Outlet, useLocation, useNavigate} from 'react-router-dom';
import { logout, selectUser } from '../../app/features/user/userSlice';
import { ProfileList, ProfileLists, ProfileNav, ProfileWrapper } from './Profile.styles';
import { links } from './dataProfileNav';

const ProfileLayout = () => {
	const dispatch = useDispatch()
	const navigate=useNavigate();
	let { pathname } = useLocation();
	const { userInfo } = useSelector(selectUser);
	return (
		<ProfileWrapper>
			<ProfileNav>
				<ProfileLists>
					{links.map(item => {
						if (userInfo?.podcaster && item.text.includes('Podcasters')) return null;
						if (item.podcasterOnly && !userInfo?.podcaster) return null;
					if (item.editorOnly && !userInfo?.editor) return null;
						return (
							<ProfileList
								key={item.id}
								// className={pathname === item.url ? "active" : ""}
							>
								{item.text === 'Logout' ? (
									<div
										className="logout-link"
										onClick={() => {
											dispatch(logout());
											navigate('/');
										}}
										style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
									>
										<>{item.icon}</>
										<span>{item.text}</span>
									</div>
								) : (
									<NavLink to={item.url}>
										<>{item.icon}</>
										<span>{item.text}</span>
									</NavLink>
								)}




								{/*<NavLink*/}
								{/*	to={item.url}*/}
								{/*	// className={pathname === item.url ? "active" : ""}*/}
								{/*>*/}
								{/*	<>{item.icon}</>*/}
								{/*	<span>{item.text}</span>*/}
								{/*</NavLink>*/}
							</ProfileList>
						);
					})}
				</ProfileLists>
			</ProfileNav>
			<article>
				<Outlet />
			</article>
		</ProfileWrapper>
	);
};

export default ProfileLayout;
